/**
 * DoctorsBubbles
 * ======================================
 * - random toggle class in groups
 * - run only when in viewport
 */

 const ELEMENT = '.js-DoctorsBubbles'
 const TOGGLE_CLASS = 'is-visible'
 const TIME = 4000
 const ITEMS_DELAY = 100

 class DoctorsBubbles {
   constructor() {
     this.element = document.querySelector(ELEMENT)

     if (!this.element) {
       return false
     }

     this.groups = this.element.querySelectorAll('.doctors-bubbles__group')
     this.elements = this.element.querySelectorAll('.doctors-bubbles__group .doctors-bubbles__item')

     let options = {
      threshold: 1.0
    }

    let observer = new IntersectionObserver(this.callback, options);

    observer.observe(document.querySelector(ELEMENT));
   }

   callback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.refresh()

        this.interval = setInterval(() => {
          this.refresh()
         }, TIME);
      } else {
        clearInterval(this.interval)
      }
    });
   }

    shuffleArray = (array) => {
      let currentIndex = array.length,  randomIndex;
      while (currentIndex != 0) {

        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    }

   refresh = () => {
     var delay = 0;
     var groups = this.shuffleArray(Array.from(this.groups))

     groups.forEach(group => {
      const groupItems = group.querySelectorAll('.doctors-bubbles__item:not(.'+TOGGLE_CLASS+')')
      const currentItem = group.querySelector('.doctors-bubbles__item.'+TOGGLE_CLASS)
      const randItem = groupItems[Math.floor(Math.random() * groupItems.length)]
      delay = delay + ITEMS_DELAY;

      setTimeout(() => {
        currentItem.classList.remove(TOGGLE_CLASS)
        randItem.classList.add(TOGGLE_CLASS)
      }, delay);
     });
   }
 }

 new DoctorsBubbles()
